<template>
  <div class="box">
    <div class="box-part-main min-h-box" id="bp-left">
      <div class="partition text-center" id="partition-register">
        <div class="partition-title h2 text-white pt-20 pb-5">Tus Firmas del Plan Demo Profesional se agotaron
        </div>
        <div class="partition-text text-center pt-3">
          <p>Para seguir disfrutando de todos los beneficios es necesario que selecciones uno de los siguientes planes que tenemos para ti.</p>
        </div>
        <div class="partition-text text-center pt-3">
          <p>¿Tienes dudas o necesitas más tiempo?</p>
        </div>
        <vs-button color="rgb(255, 255, 255)" class="btn-modal text-primary font-w-600 mt-5" type="filled" @click="redirectToContact">Hablar con un asesor</vs-button>
        <vs-button color="rgb(255, 255, 255)" class="btn-modal text-white font-w-600 mt-8 mb-3 " type="flat" @click="closeModal">Omitir por ahora <feather-icon icon="ChevronsRightIcon" svgClasses="top-3 w-5 h-4 stroke-current p-relative"/></vs-button>
      </div>
    </div>
    <div class="box-part" id="bp-right">
      <div class="box-messages pt-15">

        <vx-card>
          <h3 class="text-success">Cambiar a Plan Flexible</h3>
          <ul class="mt-2">
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-success"></feather-icon>
              Sin costo mensual</li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-success"></feather-icon>
              Compra firmas a granel <a href="/buy/documents">(ver precios)</a></li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-success"></feather-icon>
              Funciones básicas</li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-success"></feather-icon>
              Soporte básico</li>
          </ul>
          <div class="text-center mt-2" >
            <vs-button color="success" @click="switchPlan(3, 'Flexible')">Seleccionar</vs-button>
          </div>

        </vx-card>

        <vx-card class="mt-5">
          <h3 class="text-secondary">Cambiar a Plan Profesional</h3>

          <ul class="mt-2">
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-secondary"></feather-icon>
              Cargo mensual de $399</li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-secondary"></feather-icon>
              15 firmas incluidas</li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-secondary"></feather-icon>
              Funciones avanzadas <a href="/buy/plans">(Ver cuales)</a></li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-secondary"></feather-icon>
              Soporte técnico avanzado</li>
            <li><feather-icon icon="CheckIcon" class="top-3 text-secondary" svgClasses="w-5 h-5 text-secondary"></feather-icon>
              <span class="font-w-600">Descuento en firmas adicionales  </span><br> <a href="/buy/documents">(ver precios)</a></li>
          </ul>
          <div class="text-center mt-2" >
            <vs-button class="btn-secundary" @click="goToCheckOut">Mejorar ahora</vs-button>
          </div>
        </vx-card>


      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../router";

export default {
  name: "demoEndingModal",
  computed: {
    planData() {
      return this.$store.state.plans.plan.data;
    },
    proPlanData() {
        return this.planData ? this.planData[1] : '';
    }
  },
  methods: {
    redirectToContact() {
      window.open('https://verificamex.com/agendar-llamada', '_blank');
    },
    switchPlan(planId, planName) {

      let instance = this;
      if (planId === 3) {
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirmación`,
          text: '¿Estás seguro de cambiar al plan ' + planName + '?',
          acceptText: "Si",
          cancelText: "No",
          accept: function () {
            instance.$vs.loading({type: "point"})
            instance.$store.dispatch("plans/switchPlan", {planId: planId, paymentMethod: "CARD_METHOD", aclChangeRole: this.$acl.change})
              .then(
                () => {
                  instance.$vs.loading.close()
                  instance.$store.dispatch("alert/success", "El plan se ha cambiado éxitosamente", {root: true});
                  this.closeModal();
                  setTimeout(() => {
                    router.push("/buy/success");
                  }, 100)
                },
                () => {
                  instance.$vs.loading.close()
                  this.closeModal();
                }
              )
          }
        })
      } else {
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirmación`,
          text: '¿Estás seguro de cambiar al ' + planName + '?',
          acceptText: "Si",
          cancelText: "No",
          accept: function () {
            instance.$vs.loading({type: "point"})
            instance.$store.dispatch("plans/switchPlan", {planId: planId, paymentMethod: "CARD_METHOD", aclChangeRole: this.$acl.change})
              .then(
                () => {
                  instance.$vs.loading.close()
                  instance.$store.dispatch("alert/success", "El plan se ha cambiado éxitosamente", {root: true});
                  this.closeModal();
                  setTimeout(() => {
                    router.push("/buy/success");
                  }, 100)
                },
                () => {
                  instance.$vs.loading.close();
                  this.closeModal();
                }
              )
          }
        })
      }
    },
    closeModal() {
      router.app.$modal.hide('demoEnding');
    },
    goToCheckOut() {
      router.app.$modal.hide('demoEnding');
      router.push({'name': 'plan-payment', params: {'planDetail': this.proPlanData, 'intervalDetail': 'mes', 'isSubscription': true }})
    },
    openChat() {
      router.app.$modal.hide('demoEnding');
      window.Beacon('open');
    }
  },
  created() {
    this.$store.dispatch("plans/getAll", {});
  }
}
</script>

<style scoped>

</style>
